import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { supabaseClient } from "../../../lib/supabase";

import useInvalidateDiaries from "../../diaries/features/edit/api/invalidateDiaries";

interface SharedAttributesUpdate {
	shared_attribute_id: string;
	start_date?: string | null;
	end_date?: string | null;
	reference_date?: string | null;
	hospital_number?: string | null;
	contact_id?: string | null;
}

export async function updateSharedAttributes(
	attributes: SharedAttributesUpdate,
) {
	const { data, error } = await supabaseClient
		.from("shared_attributes")
		.update(attributes)
		.eq("shared_attribute_id", attributes.shared_attribute_id)
		.select("*")
		.single();

	if (error) throw error;
	return data;
}

export const useUpdateSharedAttributes = () => {
	const invalidateDiaries = useInvalidateDiaries();

	return useMutation({
		mutationKey: ["update-shared-attributes"],
		mutationFn: (attributes: SharedAttributesUpdate) =>
			updateSharedAttributes(attributes),
		onError: () => {
			toast.error("Error updating shared attributes");
		},
		onSuccess: () => {
			toast.success("Shared attributes updated");
		},
		onSettled: () => {
			invalidateDiaries();
		},
	});
};
